import axios from "../../utils/axios";

export type TabServicesStateResponse = {
    isReadonly: boolean;
    readonlyReason: string;
}

export const getTabServicesState = (rfpId: string) => axios
    .get(`/api/v1/frontend/tenders/facility-manager/${ rfpId }/tab-services-state`)
    .then((response: { data: { data: TabServicesStateResponse } }) => response.data.data)
